import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalInvestigationsForeignModel } from './types';
import { legalInvestigationsForeignItemValidator } from './validators/item';

const legalInvestigationsForeignValidator: ValidateJSModel<LegalInvestigationsForeignModel> = {
  HasForeignInvestigations: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasForeignInvestigations && attributes?.HasForeignInvestigations.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsForeignItemValidator },
      };
    }
    return {};
  },
};
export default legalInvestigationsForeignValidator;
